import clsx from 'clsx';
import React, { forwardRef, useContext } from 'react';
import { ProfileContext } from '../../../contexts/profileContext';
import { Spinner } from '../../common';

const ButtonPlatform = forwardRef(
  ({ onClick, className, children, loading, selected, isMini = false, ...props }, ref) => {
    const [profile] = useContext(ProfileContext);
    const {
      masterOrganization: { customConfigurations: { colors, buttonRadius = '9999px' } = {} } = {}
    } = profile;

    return (
      <button
        ref={ref}
        {...props}
        className={clsx(
          'self-start font-bold bg-backgroundGrey text-textAndIcons flex items-center gap-2 shadow',
          className,
          isMini ? 'px-4 py-1 text-md' : 'px-6 py-2 text-lg',
          'transition-all duration-300 hover:scale-105 active:scale-95'
        )}
        style={{
          borderRadius: buttonRadius,
          backgroundColor: selected ? colors?.primary : '',
          color: selected ? '#ffffff' : ''
        }}
        disabled={loading}
        onClick={onClick}>
        {children}
        <Spinner isSubmitting={loading} color="rgb(81 81 81)" />
      </button>
    );
  }
);

export default ButtonPlatform;
